import { CompanyRequestError } from '@/company/api';
import type copy from '@/i18n/ns/library-deletion';

export function archiveError(error: unknown, text: Record<keyof typeof copy.en, string>) {
  if (!(error instanceof CompanyRequestError)) return text.error;
  if (['file_archive_conflict', 'workspace_archive_conflict'].includes(error.code))
    return text.busyError;
  if (['file_restore_expired', 'workspace_archive_expired'].includes(error.code))
    return text.expiredError;
  if ([403, 404].includes(error.status)) return text.unavailableError;
  return text.error;
}
